import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-PreferredDealShape",
  "use": "svg-icon-PreferredDealShape-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-PreferredDealShape\"><path d=\"M8 4v7H7V4.333L5 5V4l3-1v1zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol